import { connect } from 'react-redux';
import { Footer } from '../../../footer';
import { footerSelector } from '../../../../../../../../redux/product/product.selectors';
import { footerDispatcher } from '../../../../../../../../redux/product/product.dispatchers';
export default connect(footerSelector, footerDispatcher)(Footer);